import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';


const Offer = ( { aid, uid, meta, offers } ) => {
    let params = useParams();
    const [ o, setOffer ] = useState( {
        details: {}
    } );
    
    useEffect( () => {
        console.log( 'm: ', meta );
    }, [ meta ] );

    useEffect( () => {
        console.log( 'o: ', offers[params.oid] );
        if ( offers[params.oid] ) {
            setOffer( prev => {
                return {
                    ...prev,
                    details: offers[params.oid]
                }
            } );
        }
    }, [ params.oid, offers ] );

    useEffect( () => {
        document.title = `Third Floor - ${o?.details?.name}`;
    }, [ o ] );

    return (
        <TFObject key={params.oid} objType='offer' obj={o} oid={params.oid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.offer,
    offers: state.offers.byId
} );

const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.leadopps.loadLeadOpp
} );

export default connect( mapProps, mapDispatch )( Offer );